var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPfeilDropdownRechts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Pfeil-Dropdown-rechts__Icn/40px/Pfeil-Dropdown-rechts",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Pfeil-Dropdown-rechts__Icn/20px/Icon-Platzhalter-Transparent",
    transform: "rotate(-90 20 20)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Pfeil-Dropdown-rechts__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20,14.5 L26.5,24.5 L13.5,24.5 L20,14.5 Z M20,17.505 L16.5363125,22.8333333 L23.462875,22.8333333 L20,17.505 Z",
    id: ".._.._src_svg_Icn_40px_Pfeil-Dropdown-rechts__Triangle",
    transform: "matrix(0 -1 -1 0 39.5 39.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfeilDropdownRechts);
export default __webpack_public_path__ + "static/media/Pfeil-Dropdown-rechts.1a8dbe6f9b9236b0d06e3ea8573b4ea4.svg";
export { ForwardRef as ReactComponent };